<template>
    <div>
        <h4>{{ 'My skills' | trans }}</h4>

        <MessageBox
                v-if="errorMessage !== null"
                v-bind:message="errorMessage"
                type="error">
        </MessageBox>
        <template v-else>
            <Spinner
                v-if="status === 'loading'"
                v-bind:title="'Loading...' | trans">
            </Spinner>
            <Spinner
                v-else-if="status === 'updating'"
                v-bind:title="'Saving...' | trans">
            </Spinner>
            <template v-else>
                <template v-if="user.isPureContact === true && user.workerIsNovice !== true" class="">
                    <p class="alert alert-info">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{ 'Your bid for a low-cost job will be equal to X% of your normal-cost bid.'|trans({percent: percentageLowCost }) }}
                        <br>
                        <button class="btn btn-xs btn-default" @click="isReadMoreShown=!isReadMoreShown">{{ 'Read more' | trans}}</button>
                        <span v-if="isReadMoreShown">
                          {{"The low-cost prices are displayed on Belfix" | trans({currency: $currency.symbol(user.country) }) }}
                        </span>
                    </p>
                  <p class="alert alert-danger alert-danger-by-gilles">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{'Attention, the methode has changed'|trans }}
                  </p>

                </template>

                <div class="skills-job-type-node row">


                    <div class="tutorial-btns">
                      <span class="btn-control-partner-price btn-control-partner-price-left tutorial-btn"> <i class="fa fa-minus"></i> 5{{ $currency.symbol(user.country)}} </span>
                      <span class="max-partner-price low-cost tutorial-price">
                          {{"Your price"|trans}}
                      </span>
                      <span class="btn-control-partner-price btn-control-partner-price-right tutorial-btn"> <i class="fa fa-plus"></i> 5{{ $currency.symbol(user.country)}} </span>
                    </div>


                    <SkillsJobTypeNode
                            v-for="jobType in rootJobTypesOrdered"
                            v-bind:key="jobType.id"
                            v-bind:jobType="jobType"
                            v-bind:user="user">
                    </SkillsJobTypeNode>
                </div>

                <div class="fixed-bottom">
                    <button
                            v-on:click="onCancelClick"
                            class="btn btn-default">
                        {{ 'Cancel' | trans }}
                    </button>
                    <button
                            v-if="thereAreChanges"
                            v-on:click="update"
                            class="btn validate-button pull-right">
                        {{ 'Validate' | trans }}
                    </button>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    import SkillsJobTypeNode from './SkillsJobTypeNode';
    import {hydrateAndLinkJobTypes} from '../../../../../vue-widgets/src/JobType/JobType';
    import _ from 'lodash';
    import Spinner from '../Spinner';
    import MessageBox from '../Availabilities/MessageBox';

    export default {
        props: {
            user: Object,
        },
        data() {
            return {
                jobTypes: null,
                initialJobTypesIds: null,
                status: null,
                errorMessage: null,
                isReadMoreShown : false,
                defaultSelection : []
            };
        },
        async created() {
            try {
                this.status = 'loading';
                await this.load();
                this.status = 'loaded';
            }
            catch (error) {
                if (this.$api.is401(error)) {
                    // in case of 401, just abort javascript execution
                    return;
                }
                if (this.$api.isNoConnectivity(error)) {
                    this.errorMessage = this.$options.filters.trans('No connection ?');
                } else {
                    this.$bugsnagClient.notify(error);
                    this.errorMessage = this.$options.filters.trans('Unknown error');
                }
            }
        },
        methods: {
            percentageLowCost(){
                const $percentage = (this.user.pricePolicies.minHopeMultiplier/this.user.pricePolicies.maxHopeMultiplier)*100;
                return Math.round($percentage);
            },
            async load() {
                const jobTypes = await this.$api.jobType.tree(); // theoretically not needed at each load()...
                hydrateAndLinkJobTypes(jobTypes);

                // initialize selections status from api
                const workerJobTypes = await this.$api.jobType.list();
                this.initialJobTypesIds = workerJobTypes.map(workerJobType => workerJobType.id);
                for (const jobType of Object.values(jobTypes)) {
                    jobType.selected = false;
                }
                for (const workerJobType of workerJobTypes) {
                    jobTypes[workerJobType.id].selected = true;
                    jobTypes[workerJobType.id].maxPartnerPrice = workerJobType.maxPartnerPrice;
                    jobTypes[workerJobType.id].regionsSkillsSelected = workerJobType.regionsSkillsSelected;
                }

                for (const jobType of Object.values(jobTypes)) {
                    jobType.intitiallySelected = jobType.selected;
                    jobType.initialMaxbid = jobType.maxPartnerPrice;
                    if(jobType.regionsSkillsSelected === undefined ){
						          jobType.regionsSkillsSelected = this.defaultSelection;
					          }
				        }
                this.jobTypes = jobTypes;
            },
            async update() {
                try {
                    this.status = 'updating';
                    await this.$api.jobType.update(this.selectedAndEditedJobTypesIds);
                }
                catch (error) {
                    if (this.$api.is401(error)) {
                        // in case of 401, just abort javascript execution
                        return;
                    }
                    if (this.$api.isNoConnectivity(error)) {
                        this.errorMessage = this.$options.filters.trans('No connection ?');
                    } else {
                        this.$bugsnagClient.notify(error);
                        this.errorMessage = this.$options.filters.trans('Unknown error');
                    }
                    return;
                }
                this.$router.push({name: 'jobs'});
            },
            onCancelClick() {
                this.$router.push({name: 'jobs'});
            }
        },
        computed: {
            rootJobTypesOrdered() {
                if (this.jobTypes === null) {
                    return null;
                }
                return Object.values(this.jobTypes)
                    .filter(jobType => jobType.parentId === null)
                    .sort((jobTypeA, jobTypeB) => jobTypeA.order > jobTypeB.order ? 1 : -1)
                ;
            },
            selectedJobTypesIds() {
                if (this.jobTypes === null) {
                    return null;
                }
                return Object.values(this.jobTypes).filter(jobType => jobType.selected === true).map(jobType => jobType.id);
            },
            selectedAndEditedJobTypesIds() {
                if (this.jobTypes === null) {
                    return null;
                }
                return Object.values(this.jobTypes).filter(
                    jobType => jobType.selected === true || jobType.maxPartnerPrice !== jobType.initialMaxbid
                ).map(
                    jobType => {
						return {
							'jobTypeId': jobType.id,
							'maxPartnerPrice': jobType.maxPartnerPrice,
							'regionsSkillsSelected': jobType.regionsSkillsSelected
						}
                    }
                );
            },
            // ONLY FOR VISUAL
            thereAreChanges() {
                if (this.jobTypes === null) {
                    return false;
                }
                return Object.values(this.jobTypes).some(
                	jobType => jobType.selected !== jobType.intitiallySelected ||
                        jobType.maxPartnerPrice !== jobType.initialMaxPartnerPrice
                        // TODO ADD REGION SELECTION VISUAL
                    );
            }
        },
        components: {
            Spinner,
            SkillsJobTypeNode,
            MessageBox
        }
    }
</script>




<style lang="css">
button {
  background: lightskyblue;
}
.fixed-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  /*background: #677a87;*/
  background: #35464f;
  z-index: 10;
}
.fixed-bottom button {
  margin: 10px;
  font-size: 18px;
}
.fixed-bottom .validate-button {
  background: #607db8;
  color: white;
  font-weight: bold;
}
/* INFO: >>> to allow a scoped style to have effect on elements on a descendant component */
.max-partner-price {
  padding: 8px 7px;
  font-size: 14px;
  //border-radius: 6px;
  white-space: nowrap;
  line-height: 39px !important;
}

.low-cost {
   padding: 9px 10px;
   background: #607db8;
   color: white;
   font-weight: bold;
 }
.normal-cost {
   padding: 8px 7px;
   background: #ffbfbf;
   border-top-left-radius: 0;
   border-bottom-left-radius: 0;
 }

.btn-control-partner-price{
  background-color: #35464f !important;
  color: white;
  padding: 9px 14px;
  text-align: center;
  font-size: 14px;
}

.btn-control-partner-price-left{
  border-radius: 4px 0px 0px 4px;
}

.btn-control-partner-price-right{
  border-radius: 0px 4px 4px 0px;
}

.skills-job-type-node{
  background-color: #fdfdfd;
  margin-top:20px;
  padding:4px;
  border-top:1px solid #e4e4e4;
  margin-bottom: 100px;
}

.tutorial-btn{
  background: #35464f !important;
}
.tutorial-price{
  background: #607db8 !important;
  font-weight: bold;
}

/**
 I'm doing this because Gilles ask for
 */
.alert-danger-by-gilles{
  background: #fb5a5a !important;
  border-color:#fb927d !important;
  color:#FFFFFF !important;
}

.tutorial-btns-container{
  text-align: right;
}
.tutorial-btns{
  font-weight: bold;
  float: right;
}
</style>